<!--
/*******************************************************************************
*@ 컴포넌트명   : myQrRpt.vue
*@ 컴포넌트설명 : myQR 이미지 저장 및 공유를 위한 팝업
*@ 사용전문     :  
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <section class="payment myqr">
    <popup :opened.sync="openData" :use-header="true" :use-footer="true" ref="popup" :btn-area-padding="true" title="MPAY-05-01-01-01" @cancel="popupClose">
      <template #content>
        <article class="contents">
          <!-- qr-->
          <div class="myqr-wrap">
            <p class="logo-group">
              <span class="logo-group-item vietqr"><i class="icon myqr-logo-vietqr">VIETQR</i></span>
              <!-- myqr-logo: svg code, myqr-logo-xxxxxx-2 : @3x.png -->
            </p>
            <div class="qr">
              <div id="myQr3" ref="myQrDiv2">
                <i class="icon myqr-sampleQR"></i>
              </div>
            </div>
            <p class="logo-group">
              <span class="logo-group-item"><i class="icon myqr-logo-napas247">NAPAS247</i></span>
              <span class="logo-group-item"><i class="icon myqr-logo-kbbank">KB Kookmin Bank</i></span>
            </p>
          </div>
          <!--// qr -->
          <div class="qrinfo-txt">
            <p v-if="detailInfo.amount != 0">{{ /* 금액 */ $t("MPAY-05-01-01-04") }} : VND {{ $num(detailInfo.amount, 0) }}</p>
            <p>{{ /* 수취인명 */ $t("MPAY-05-01-01-02") }} : {{ detailInfo.beneName }}</p>
            <p>{{ /*수취 계좌번호*/ $t("MFXD-01-03-01-03") }} : {{ detailInfo.account }}(VND)</p>
            <p v-if="operGroupCd == 'VN1'">{{ /* 은행 */ $t("MFXD-01-01-11-05") }} : KOOKMIN HO CHI MINH - KB HCM</p>
            <p v-else>{{ /* 은행 */ $t("MFXD-01-01-11-05") }} : KOOKMIN HA NOI - KB HN</p>
          </div>
          <!-- <div class="btn-area--icon al_bottomcenter">
              <button class="btn icon"  @click.prevent="click"><i class="icon icon-download-02"></i><em>저장</em></button>
              <button class="btn icon" @click.prevent="click2"><i class="icon icon-share"></i><em>공유</em></button>
            </div> -->
          <!-- </div> -->
        </article>
        <!-- <div :class="['toasts', { hide: hasFlaggedItems }]">
          <div class="toast" v-for="item in items" :key="item.id" :id="item.id">
            <div class="toast-body">
              <i class="icon icon-check" /> {{ item.body }}
            </div>
          </div>
        </div> -->
      </template>
      <template #footer>
        <button class="btn bottom positive" @click="popupClose()">{{ /*확인*/ $t("MPAY-04-01-10-21") }}</button>
      </template>
    </popup>
  </section>
</template>
<script>
import { mapFields } from "vuex-map-fields";
import QRCodeStyling from "@/assets/js/qr-code-styling.min.js"; // qr styling
export default {
  props: {
    opened: {
      type: Boolean,
      default: false,
    },
    detailInfo: {
      type: Object,
      required: true,
    },
  },
  data(){
    return {
      qrStr : this.detailInfo.qrStr,  // qrString 전달
      myQr3 : "",
      qrBoxWidth : "",
      qrBoxHeight : "",
    }
  },
  computed: {
    ...mapFields(["siteCode", "operGroupCd"]),
    openData: {
      get() {
        console.log(JSON.stringify(this.detailInfo) + "_"+ this.opened);
        if(this.opened){
          this.generateQRCode2();
        }
        
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },

    },
  },
  created: function(){

  },
  mounted: function(){

  },
  methods: {
    popupClose() {
      this.openData = false;
      this.$emit("popupClose", false);
    },
    generateQRCode2(){
      console.log(this.$refs.popup)
      this.myQr3 = document.getElementById("myQr3");
      this.qrBoxWidth = this.$refs.myQrDiv2.$el.clientWidth;
      this.qrBoxHeight = this.$refs.myQrDiv2.$el.clientWidth;
      console.log("myQrRpt" + this.qrStr);
      this.imgName = "design__default_icon-qr-kbmark";  
      const qrCode = new QRCodeStyling({
        width: this.qrBoxWidth,
        height: this.qrBoxHeight,
        data: this.qrStr,
        image: require(`@/assets/images/${this.imgName}.svg`),
        imageSettings: {
          excavate: true, // 로구를 QR 코드 주위에 원 형태로 둘러싸는 효과
          roundedBorders: true, // 로고 주위에 경계선을 그리기
        },
        imageOptions: {
          crossOrigin: "anonymous",
          hideBackgroundDots: false,
        },
        qrOptions: {
          typeNumber: 7, // QR String 사이즈 픽스해서 QR 버전 고정
          errorCorrectionLevel: "M"
        },
        type: "svg"
      });
      //  document.getElementById("myQr3").style.transform = "scale(0.9) translate(-55%, 1.7%)"    
      qrCode.append(document.getElementById("myQr3"));
    }
  },
};
</script>
